import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Col } from 'reactstrap';

const TermsContainer = styled(Col)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TermsContent = styled.div`
  padding: 15px;
  white-space: pre-wrap; /* Keeps the formatting of text files. */
  max-width: 800px;
`;

const TermsOfService = () => {
  const [termsText, setTermsText] = useState('');

  useEffect(() => {
    fetch('/website-terms-of-use.txt')
      .then(response => response.text())
      .then(text => setTermsText(text));
  }, []);

  return (
    <TermsContainer>
      <h1>Website Terms of Use</h1>
      <TermsContent>{termsText}</TermsContent>
    </TermsContainer>
  );
};

export default TermsOfService;